define [], () ->
  () ->
    restrict: "E"
    template: require("./multi_line.jade")
    scope: {field: "=", mode: "@", index: "=", stage: "="}
    link: (scope, element, attrs) ->
      if scope.field.required and scope.mode == 'edit'
        scope.field_label = "#{scope.field.label}<span>&nbsp;*</span>"
      else
        scope.field_label = scope.field.label



// WEBPACK FOOTER //
// ./directives/freeforms/multi_line/multi_line.coffee